"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecord = exports.extendLinksFullPath = exports.discordInviteCode = exports.profileHandler = exports.collectionName = exports.collectionSymbol = exports.address = exports.isodate = exports.isodateString = exports.integer = exports.notEmpty = exports.zeroOrPositive = exports.gtZero = exports.positive = void 0;
const superstruct_1 = require("superstruct");
const slug_1 = __importDefault(require("./validation/slug"));
// eslint-disable-next-line
// @ts-ignore
const is_iso_date_1 = __importDefault(require("is-iso-date"));
__exportStar(require("./web3"), exports);
__exportStar(require("./url"), exports);
const web3_1 = require("./web3");
/**
 * Superstruct validation
 */
const positive = (val) => (0, superstruct_1.refine)(val, 'positive', value => value >= 0);
exports.positive = positive;
const gtZero = (val) => (0, superstruct_1.refine)(val, 'positive', value => value > 0);
exports.gtZero = gtZero;
const zeroOrPositive = (val) => (0, superstruct_1.refine)(val, 'positive', value => value >= 0);
exports.zeroOrPositive = zeroOrPositive;
const notEmpty = (val) => (0, superstruct_1.refine)(val, 'notEmpty', value => value.length > 0);
exports.notEmpty = notEmpty;
const integer = (val) => (0, superstruct_1.refine)(val, 'integer', value => (value | 0) === value);
exports.integer = integer;
/**
 * Take date or string and convert it to a string in ISO date format
 */
const isodateString = () => (0, superstruct_1.coerce)((0, superstruct_1.string)(), (0, superstruct_1.date)(), val => {
    if (val.toISOString) {
        return val.toISOString();
    }
    return val;
});
exports.isodateString = isodateString;
/**
 * ensure that string has ISO date format without coecrion to Date object
 */
const isodate = (val) => (0, superstruct_1.refine)(val, 'isodate', is_iso_date_1.default);
exports.isodate = isodate;
const address = (val) => (0, superstruct_1.refine)(val, 'address', web3_1.isValidPublicKey);
exports.address = address;
const ALPHA_NUM = /^[a-zA-Z0-9]+$/;
exports.collectionSymbol = (0, superstruct_1.size)((0, slug_1.default)(), 3, 64);
exports.collectionName = (0, superstruct_1.size)((0, superstruct_1.string)(), 3, 128);
exports.profileHandler = (0, superstruct_1.size)((0, superstruct_1.string)(), 4, 108);
exports.discordInviteCode = (0, superstruct_1.define)('discordInviteCode', (val) => {
    if (!(0, superstruct_1.is)(val, (0, superstruct_1.size)((0, superstruct_1.string)(), 3, Infinity))) {
        return 'Invite code should be at least 3 chars long';
    }
    if (!ALPHA_NUM.test(val)) {
        return 'Please enter the part of your discord invite after “https://discord.gg/”';
    }
    return true;
});
/**
 * Helper functions
 */
const extendLinksFullPath = (links) => {
    const transformed = {};
    for (const resourceName in links) {
        const path = links[resourceName];
        if (!path) {
            continue;
        }
        switch (resourceName) {
            case 'twitter':
                transformed[resourceName] = `https://twitter.com/${path}`;
                break;
            case 'discord':
                transformed[resourceName] = `https://discord.gg/${path}`;
                break;
            case 'telegram':
                transformed[resourceName] = `https://t.me/${path}`;
                break;
            default:
                transformed[resourceName] = path;
        }
    }
    return transformed;
};
exports.extendLinksFullPath = extendLinksFullPath;
/**
 * Type guards
 */
const isRecord = (value) => {
    return typeof value === 'object' && !Array.isArray(value) && value !== null;
};
exports.isRecord = isRecord;
__exportStar(require("./cleanDeep"), exports);
__exportStar(require("./httpClient"), exports);
__exportStar(require("./time"), exports);
__exportStar(require("./image"), exports);
__exportStar(require("./inscriptions"), exports);
